import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ServiceItemCostService', ServiceItemCostService);

  ServiceItemCostService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'ServiceItemCostModalService',
  ];

  function ServiceItemCostService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    ServiceItemCostModalService
  ) {
    let utils = new UtilService(this);

    $translate = $filter('translate');

    let apiUrl = environment.apiEndpoint + 'service_items';

    let service = {
      searchServiceItemCosts: searchServiceItemCosts,
      saveServiceItemCosts: saveServiceItemCosts,
      openServiceItemCostsModal: openServiceItemCostsModal,
    };

    return service;

    ////////////////

    function searchServiceItemCosts(serviceItem, filterCriteria) {
      let url = apiUrl + '/' + serviceItem.id + '/service_item_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = serviceItem.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveServiceItemCosts(serviceItem, params, editMode) {
      let url = apiUrl + '/' + serviceItem.id + '/service_item_costs';

      params.company_id = serviceItem.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        let msg = !editMode ? 'COSTS_ADDED' : 'UPDATED_COSTS';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }

    function openServiceItemCostsModal(
      serviceItem,
      provider,
      viewOption,
      userLanguageCode,
      successCallback
    ) {
      ServiceItemCostModalService.openServiceItemCostsModal(
        serviceItem,
        provider,
        viewOption,
        userLanguageCode,
        successCallback
      );
    }
  }
})();
